import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  SimpleGrid,
  Box,
  Input,
  FormLabel,
  Select,
  InputGroup,
  InputLeftAddon,
  useDisclosure,
  Checkbox,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import axios from "axios";
import toast from "react-hot-toast";
import Cookie from "js-cookie";

const FoodUpdateModal = ({
  isOpen,
  onClose,
  id,
  customerId,
  onOpen,
  unique,
  setSelectId,
  data,
}) => {
  const token = Cookie.get("token");
  const [selectedFile, setSelectedFile] = useState(null);
  const [newImageURL, setnewImageURL] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    category: "",

    acRate: 0,
    nonAcRate: 0,
    sgst: 0,
    cgst: 0,
    nonAcSgst: 0,
    nonAcCgst: 0,
    acHalfRate: 0,
    acHalfSgst: 0,
    acHalfCgst: 0,
    nonAcHalfRate: 0,
    nonAcHalfCgst: 0,
    nonAcHalfSgst: 0,

    image: "",
    type: "",
    code: "",
    hsnNo: "",
    halfPlate: false,
    gstPercentage: 0,
  });

  console.log(unique, "unique");

  console.log(Object.keys(data) + " :" + Object.values(data), "data");

  useEffect(() => {
    if (data) {
      setFormData({
        name: data.name || "",
        description: data.description || "",
        category: data.category || "",

        acRate: data.acRate || 0,
        nonAcRate: data.nonAcRate || 0,
        sgst: data.sgst || 0,
        cgst: data.cgst || 0,
        nonAcSgst: data.nonAcSgst || 0,
        nonAcCgst: data.nonAcCgst || 0,
        acHalfRate: data.acHalfRate || 0,
        acHalfSgst: data.acHalfSgst || 0,
        acHalfCgst: data.acHalfCgst || 0,
        nonAcHalfRate: data.nonAcHalfRate || 0,
        nonAcHalfCgst: data.nonAcHalfCgst || 0,
        nonAcHalfSgst: data.nonAcHalfSgst || 0,

        image: data.image || "",
        type: data.type || "",
        code: data.code || "",
        halfPlate: data.halfPlate || false,
        hsnNo: data.hsnNo || "",
        gstPercentage: data.gstPercentage || 0,
      });
    }
  }, [data]);
  const scroll = "inside";

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  useEffect(() => {
    setFormData({
      ...formData,
      sgst: formData.acRate * (formData.gstPercentage / 200),
      cgst: formData.acRate * (formData.gstPercentage / 200),
      nonAcSgst: formData.nonAcRate * (formData.gstPercentage / 200),
      nonAcCgst: formData.nonAcRate * (formData.gstPercentage / 200),
      acHalfSgst: formData.acHalfRate * (formData.gstPercentage / 200),
      acHalfCgst: formData.acHalfRate * (formData.gstPercentage / 200),
      nonAcHalfSgst: formData.nonAcHalfRate * (formData.gstPercentage / 200),
      nonAcHalfCgst: formData.nonAcHalfRate * (formData.gstPercentage / 200),
    });
  }, [
    formData.gstPercentage,
    formData.acRate,
    formData.nonAcRate,
    formData.acHalfRate,
    formData.nonAcHalfRate,
  ]);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };
  const handlePost = async () => {
    try {
      setUploading(true);

      if (!selectedFile) {
        toast.error("Please select a file to upload.");
        return;
      }

      const formData = new FormData();
      formData.append("image", selectedFile); // Ensure 'image' matches the backend field name

      const response = await axios.post(
        "https://api.rasoi.launchlysoftware.in/upload", // Corrected URL
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      const data = response.data;

      // Update state with uploaded image URL
      setnewImageURL(data.filename); // Adjust based on backend response
      toast.success("Image uploaded successfully");
      console.log(data, "Upload response");
    } catch (err) {
      console.error("Upload failed:", err);
      toast.error("Image upload failed. Please try again.");
    } finally {
      setUploading(false);
    }
  };
  console.log(newImageURL, "newImageURL");
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: checked, // Set formData.halfPlate to true/false based on checkbox state
    }));
  };
  const generateGst = () => {
    setFormData((prev) => ({
      ...prev,
      sgst: prev.acRate * 0.025,
      cgst: prev.acRate * 0.025,
      nonAcSgst: prev.nonAcRate * 0.025,
      nonAcCgst: prev.nonAcRate * 0.025,
      acHalfSgst: prev.acHalfRate * 0.025,
      acHalfCgst: prev.acHalfRate * 0.025,
      nonAcHalfSgst: prev.nonAcHalfRate * 0.025,
      nonAcHalfCgst: prev.nonAcHalfRate * 0.025,
      image: newImageURL || prev.image,
    }));
  };
  const handleSubmit = (e) => {};
  const handleEdit = async (e) => {
    e.preventDefault();
    const updatedFormData = {
      ...formData,
      image: newImageURL || formData.image,
    };

    console.log(formData, "formData");

    try {
      // Make the PUT request with formData directly
      const response = await axios.put(
        `https://api.rasoi.launchlysoftware.in/api/updateFoodData/${customerId}/${id}?customerId=${customerId}`,
        { data: updatedFormData },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      toast.success(response.data.message);
      console.log(response, "response");
      //setSelectId(null);
      // Optionally reset the form after a successful update
      setFormData({
        name: "",
        description: "",
        category: "",
        image: "",

        acRate: 0,
        nonAcRate: 0,
        sgst: 0,
        cgst: 0,
        nonAcSgst: 0,
        nonAcCgst: 0,
        acHalfRate: 0,
        acHalfSgst: 0,
        acHalfCgst: 0,
        nonAcHalfRate: 0,
        nonAcHalfCgst: 0,
        nonAcHalfSgst: 0,
        hsnNo: "",

        image: "",
        type: "",
        code: "",
        halfPlate: false,
      });
      window.location.reload();
    } catch (error) {
      toast.error(error.response.data.message);
      console.error("Update failed:", error);
    }
  };
  const handleClick = () => {
    onClose();
    setSelectId(null);
  };
  return (
    <Modal
      width="full"
      size="3xl"
      isOpen={isOpen}
      onClose={onClose}
      onOpen={onOpen}
      scrollBehavior={scroll}
    >
      <ModalOverlay />
      <ModalContent bg="#f9f1e3">
        <ModalHeader
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >
          <Text>Food Data- {data?.name}</Text>
          <Button colorScheme="red" onClick={handleClick}>
            <IoMdClose />
          </Button>
        </ModalHeader>

        <ModalBody>
          <SimpleGrid columns={2} gap={4} placeItems="left">
            <InputGroup>
              <InputLeftAddon>Name</InputLeftAddon>
              <Input
                bg="white"
                onChange={handleInputChange}
                name="name"
                placeholder="Enter name"
                value={formData.name}
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Description</InputLeftAddon>
              <Input
                bg="white"
                onChange={handleInputChange}
                name="description"
                placeholder="Enter Description"
                value={formData.description}
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Category</InputLeftAddon>
              <Select
                width="70%"
                type="date"
                bg="white"
                onChange={handleInputChange}
                name="category"
                placeholder="Enter Category"
                value={formData.category}
              >
                {unique.map((name) => (
                  <option key={name._id} value={name}>
                    {name}
                  </option>
                ))}
              </Select>
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>HsnNo</InputLeftAddon>
              <Input
                width="70%"
                bg="white"
                onChange={handleInputChange}
                name="hsnNo"
                placeholder="Enter HsnNo"
                value={formData.hsnNo}
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Gst%</InputLeftAddon>
              <Input
                width="70%"
                bg="white"
                onChange={handleInputChange}
                name="gstPercentage"
                placeholder="Enter Gst%"
                value={formData.gstPercentage}
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Ac Rate</InputLeftAddon>
              <Input
                bg="white"
                onChange={handleInputChange}
                name="acRate"
                placeholder="Enter Ac Rate"
                value={formData.acRate}
              />
            </InputGroup>

            {formData.halfPlate ? (
              <InputGroup>
                {" "}
                <InputLeftAddon>Ac Half Rate</InputLeftAddon>
                <Input
                  bg="white"
                  onChange={handleInputChange}
                  name="acHalfRate"
                  placeholder="Enter Ac Half Rate"
                  value={formData.acHalfRate}
                />
              </InputGroup>
            ) : (
              ""
            )}
            <InputGroup>
              <InputLeftAddon>NonAc Rate</InputLeftAddon>
              <Input
                width="68%"
                bg="white"
                onChange={handleInputChange}
                name="nonAcRate"
                placeholder="Enter NonAc Rate"
                value={formData.nonAcRate}
              />
            </InputGroup>
            {formData.halfPlate ? (
              <InputGroup>
                {" "}
                <InputLeftAddon>NonAc Half Rate</InputLeftAddon>
                <Input
                  bg="white"
                  onChange={handleInputChange}
                  name="nonAcHalfRate"
                  placeholder="Enter NonAc Half Rate"
                  value={formData.nonAcHalfRate}
                />
              </InputGroup>
            ) : (
              ""
            )}
            <InputGroup>
              <InputLeftAddon>Sgst</InputLeftAddon>
              <Input
                width="68%"
                bg="white"
                onChange={handleInputChange}
                name="sgst"
                placeholder="Enter Sgst"
                value={formData.sgst}
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Cgst</InputLeftAddon>
              <Input
                width="68%"
                bg="white"
                onChange={handleInputChange}
                name="cgst"
                placeholder="Enter Cgst"
                value={formData.cgst}
              />
            </InputGroup>
            {formData.halfPlate ? (
              <InputGroup>
                {" "}
                <InputLeftAddon>Ac Half Cgst</InputLeftAddon>
                <Input
                  bg="white"
                  onChange={handleInputChange}
                  name="acHalfCgst"
                  placeholder="Enter Ac Half Cgst"
                  value={formData.acHalfCgst}
                />
              </InputGroup>
            ) : (
              ""
            )}
            {formData.halfPlate ? (
              <InputGroup>
                {" "}
                <InputLeftAddon>Ac Half Sgst</InputLeftAddon>
                <Input
                  bg="white"
                  onChange={handleInputChange}
                  name="acHalfSgst"
                  placeholder="Enter Ac Half Sgst"
                  value={formData.acHalfSgst}
                />
              </InputGroup>
            ) : (
              ""
            )}

            <InputGroup>
              <InputLeftAddon>NonAc Sgst</InputLeftAddon>
              <Input
                width="68%"
                bg="white"
                onChange={handleInputChange}
                name="nonAcSgst"
                placeholder="Enter NonAc Cgst"
                value={formData.nonAcCgst}
              />
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>NonAc Cgst</InputLeftAddon>
              <Input
                width="68%"
                bg="white"
                onChange={handleInputChange}
                name="nonAcCgst"
                placeholder="Enter NonAc Sgst"
                value={formData.nonAcSgst}
              />
            </InputGroup>
            {formData.halfPlate ? (
              <InputGroup>
                {" "}
                <InputLeftAddon>NonAc Half Cgst</InputLeftAddon>
                <Input
                  bg="white"
                  onChange={handleInputChange}
                  name="nonAcHalfCgst"
                  placeholder="Enter NonAc Half Cgst"
                  value={formData.nonAcHalfCgst}
                />
              </InputGroup>
            ) : (
              ""
            )}
            {formData.halfPlate ? (
              <InputGroup>
                {" "}
                <InputLeftAddon>NonAc Half Sgst</InputLeftAddon>
                <Input
                  bg="white"
                  onChange={handleInputChange}
                  name="nonAcHalfSgst"
                  placeholder="Enter NonAc Half Sgst"
                  value={formData.nonAcHalfSgst}
                />
              </InputGroup>
            ) : (
              ""
            )}
            <InputGroup>
              {/* <InputLeftAddon>Half Plate Available?</InputLeftAddon> */}
              <Checkbox
                w="70%"
                bg="#fafafa"
                value={formData.halfPlate}
                name="halfPlate"
                isChecked={formData.halfPlate}
                onChange={handleCheckboxChange}
              >
                Half Available ?
              </Checkbox>
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Image</InputLeftAddon>
              <Input
                w="70%"
                type="file"
                bg="#FAFAFA "
                onChange={handleFileChange}
              />
              <Button variant="solid" onClick={handlePost} disabled={uploading}>
                {uploading ? "Uploading..." : "Upload"}
              </Button>
            </InputGroup>
            <InputGroup>
              <InputLeftAddon>Code</InputLeftAddon>
              <Input
                width="68%"
                bg="white"
                onChange={handleInputChange}
                name="code"
                placeholder="Enter Code"
                value={formData.code}
              />
            </InputGroup>
          </SimpleGrid>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap={4}
            mt={2}
          >
            {/* <Button colorScheme='yellow' onClick={generateGst} >Generate Gst</Button> */}
            <Button colorScheme="green" onClick={(e) => handleEdit(e)}>
              Edit
            </Button>
          </Box>
        </ModalBody>

        <ModalFooter></ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default FoodUpdateModal;
